var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from "react";
import styled from "styled-components";
import { Button } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../../state/store";
import * as quizAnswerActions from "../../state/quizAnswer/actions";
var StyledSubmitButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 10px 20px;\n  border-radius: 15px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);\n"], ["\n  padding: 10px 20px;\n  border-radius: 15px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);\n"])));

var SubmitButton = function SubmitButton() {
  var dispatch = useDispatch();
  var submitLocked = useTypedSelector(function (state) {
    return state.quizAnswer.submitLocked;
  });
  var languageInfo = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  var noChangesAfterSuccessfulAnswer = useTypedSelector(function (state) {
    return state.quizAnswer.noChangesSinceSuccessfulSubmit;
  });
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });

  if (quiz && quiz.deadline && new Date(quiz.deadline).getTime() < new Date().getTime()) {
    submitLocked = true;
  }

  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var noChangesAfterLoading = useTypedSelector(function (state) {
    return state.quizAnswer.noChangesAfterLoading;
  });

  if (!languageInfo) {
    return React.createElement("div", null, "language not set");
  }

  var generalLabels = languageInfo.general;
  var buttonText = generalLabels.submitButtonLabel;

  if (noChangesAfterLoading && userQuizState && userQuizState.tries > 0) {
    buttonText = generalLabels.submitButtonAlreadyAnsweredLabel;
  }

  if (noChangesAfterSuccessfulAnswer) {
    buttonText = generalLabels.submitGeneralFeedbackLabel;
  }

  var handleSubmit = function handleSubmit() {
    dispatch(quizAnswerActions.submit());
  };

  return React.createElement(StyledSubmitButton, {
    variant: "contained",
    color: "primary",
    disabled: submitLocked,
    onClick: handleSubmit
  }, buttonText);
};

export default SubmitButton;
var templateObject_1;